<script>
import AnnouncementsApi from "@/services/announcements-api";

export default {
  props: {
    propDisplayTitle: { type: Boolean, default: true },
    propWhiteBackground: { type: Boolean, default: true },
    propFullwidth: { type: Boolean, default: false },
  },
  data() {
    return {
      highlightsList: [],
    };
  },
  mounted() {
    this.getPromotionsAndNews();
  },
  methods: {
    getPromotionsAndNews() {
      AnnouncementsApi.getPromotionsAndNews(1, 100).then(result => {
        if (result) this.highlightsList = result.list;
      });
    },
  },
};
</script>


<template>
  <div class="mss-offers-section py-5" v-if="highlightsList.length > 0">
    <div :class="propFullwidth ? 'px-4' : 'home-page-80-width'" class="px-3 px-lg-0">

      <div v-if="propDisplayTitle" class="mss-section-header mb-5">
        <h2 class="mss-section-title">Offres & Nouveautés</h2>
        <div class="mss-section-line"></div>
        <p class="mss-section-sub mt-3">
          Nos dernières offres, promotions et nouveautés produits pour les professionnels de santé.
        </p>
      </div>

      <!-- ── Editorial layout ── -->
      <div class="row no-gutters mss-offers-grid">

        <!-- Featured (first item) -->
        <div class="col-12 col-lg-7 pr-lg-3 mb-3 mb-lg-0" v-if="highlightsList[0]">
          <div class="mss-offer-card mss-offer-featured">
            <img :src="'/api/image/get/' + highlightsList[0].image" class="mss-offer-img" alt="" />
            <div class="mss-offer-overlay"></div>
            <div class="mss-offer-badge-wrap" v-if="highlightsList[0].tag">
              <span class="mss-offer-badge">{{ highlightsList[0].tag }}</span>
            </div>
            <div class="mss-offer-content">
              <span class="mss-offer-date"><i class="bx bx-calendar mr-1"></i>{{ highlightsList[0].date }}</span>
              <h3 class="mss-offer-title">{{ highlightsList[0].title }}</h3>
              <p class="mss-offer-desc d-none d-md-block" v-html="highlightsList[0].description"></p>
            </div>
          </div>
        </div>

        <!-- Side stack (items 1 & 2) -->
        <div class="col-12 col-lg-5 pl-lg-3 d-flex flex-column" v-if="highlightsList.length > 1">
          <div
            v-for="(item, i) in highlightsList.slice(1, 3)"
            :key="item.id"
            class="mss-offer-card mss-offer-side flex-fill"
            :class="i === 0 ? 'mb-2' : 'mt-2'"
          >
            <img :src="'/api/image/get/' + item.image" class="mss-offer-img" alt="" />
            <div class="mss-offer-overlay"></div>
            <div class="mss-offer-badge-wrap" v-if="item.tag">
              <span class="mss-offer-badge">{{ item.tag }}</span>
            </div>
            <div class="mss-offer-content">
              <span class="mss-offer-date"><i class="bx bx-calendar mr-1"></i>{{ item.date }}</span>
              <h5 class="mss-offer-title mss-offer-title--sm">{{ item.title }}</h5>
            </div>
          </div>
        </div>

      </div>


    </div>
  </div>
</template>


<style scoped>
.mss-offers-section {
  background: #fff;
}

/* Section header */
.mss-section-title {
  font-size: 1.65rem;
  font-weight: 800;
  color: #1853ba;
  margin-bottom: 6px;
}
.mss-section-line {
  width: 40px;
  height: 3px;
  background: #8ac727;
  border-radius: 2px;
}
.mss-section-sub {
  color: #8898aa;
  font-size: 14px;
  margin-bottom: 0;
}

/* ── Cinematic card base ── */
.mss-offer-card {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  cursor: pointer;
  display: block;
}

.mss-offer-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.45s ease;
}
.mss-offer-card:hover .mss-offer-img {
  transform: scale(1.06);
}

/* Bottom-to-top gradient overlay — blue (featured) */
.mss-offer-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(12, 36, 114, 0.85) 0%,
    rgba(24, 83, 186, 0.35) 45%,
    rgba(24, 83, 186, 0.05) 100%
  );
  transition: background 0.3s ease;
}
.mss-offer-card:hover .mss-offer-overlay {
  background: linear-gradient(
    to top,
    rgba(12, 36, 114, 0.92) 0%,
    rgba(24, 83, 186, 0.50) 55%,
    rgba(24, 83, 186, 0.10) 100%
  );
}

/* Bottom-to-top gradient overlay — green (side cards) */
.mss-offer-overlay--green {
  background: linear-gradient(
    to top,
    rgba(25, 135, 84, 0.85) 0%,
    rgba(25, 135, 84, 0.35) 45%,
    rgba(25, 135, 84, 0.05) 100%
  ) !important;
}
.mss-offer-card:hover .mss-offer-overlay--green {
  background: linear-gradient(
    to top,
    rgba(25, 135, 84, 0.92) 0%,
    rgba(25, 135, 84, 0.50) 55%,
    rgba(25, 135, 84, 0.10) 100%
  ) !important;
}

/* Badge / tag */
.mss-offer-badge-wrap {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.mss-offer-badge {
  background: #1853ba;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.mss-offer-badge--new {
  background: #8ac727;
}

/* Text content at bottom */
.mss-offer-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 26px 26px;
  z-index: 2;
  text-shadow: 0 1px 6px rgba(0,0,0,0.55);
}
.mss-offer-date {
  display: block;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 8px;
}
.mss-offer-title {
  font-size: 1.45rem;
  font-weight: 800;
  color: #fff;
  margin: 0 0 10px;
  line-height: 1.3;
}
.mss-offer-title--sm  { font-size: 1.15rem; margin-bottom: 0; }
.mss-offer-title--xs  { font-size: 1rem; margin-bottom: 0; }

.mss-offer-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.65;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Heights ── */
.mss-offer-featured { height: 440px; }
.mss-offer-side     { height: 213px; min-height: 160px; }

/* Left accent line on featured hover */
.mss-offer-featured::after {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #8ac727, #1853ba);
  border-radius: 14px 0 0 14px;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 3;
}
.mss-offer-featured:hover::after {
  opacity: 1;
}

@media (max-width: 991px) {
  .mss-offer-featured { height: 320px; }
  .mss-offer-side     { height: 180px; }
}
@media (max-width: 575px) {
  .mss-offer-featured { height: 260px; }
  .mss-offer-side     { height: 160px; }
  .mss-offer-mini     { height: 180px; }
}
</style>
